import Cookies from 'universal-cookie';

const useCookie = ()=> {
    const cookies = new Cookies();

    const setCookie = (name, value)=> {
        cookies.set(name, value, { path: '/' });
    }

    const getCookie = (name) => {
        return cookies.get(name)
    }

    const deleteCookie = (name)=> {
        cookies.remove(name);
    }
    
    return {setCookie, getCookie, deleteCookie}
}

export default useCookie;